export default function JiliScrollIcon({ onOpen, currentStage }) {
  if (!currentStage) {
    return null;
  }

  return (
    <div
      className="jili-quest-icon"
      onClick={onOpen}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onOpen();
        }
      }}
    >
      <img
        src={currentStage.logo}
        alt={currentStage.gameName || "Jili Quest"}
      />
    </div>
  );
}
